// Presentation only: native action flags remain the authority for commands.
export function savedTransferCheckActive(status) {
  return status?.checkingSavedTransfer === true && status?.busy === true
    && status?.recovery?.state !== 'recovery-pending' && status?.previousCache?.recovering !== true
    && !['quiescing', 'activating', 'recovery-pending', 'cleanup-pending', 'removing-failed-transfer'].includes(status?.import?.phase);
}

export function transferAttention(status, admin) {
  const imported = admin ? status?.import : null;
  const previous = admin ? status?.previousCache : null;
  const recovery = status?.recovery?.state === 'recovery-pending'
    || imported?.phase === 'recovery-pending' || previous?.recovering === true;
  const receive = admin && savedTransferCheckActive(status) ? 'checking-saved-transfer'
    : ['awaiting-confirmation', 'refused-before-activation', 'resumable', 'prepared', 'failed', 'complete', 'preparation-stale', 'cleanup-pending'].includes(imported?.phase)
    ? imported.phase : null;
  const backup = previous?.cleanupState === 'failed' ? 'failed'
    : previous?.cleanupPending ? `cleanup-${previous.cleanupState || 'waiting'}`
      : previous?.available ? 'available' : previous?.reason === 'consumed' ? 'restored' : null;
  const operation = status?.operation;
  const operationTab = ['prepare', 'disable'].includes(operation?.kind) ? 'setup'
    : operation?.kind === 'export' ? 'send'
      : ['restorePrevious', 'deletePrevious'].includes(operation?.kind) ? 'backup' : 'receive';
  return { recovery, receive, backup,
    operation: operation?.phase === 'failed' ? `${operationTab}:failed` : null };
}

// Only transitions select a tab; polling/revision changes and manual navigation do not.
export function nextAttentionTab(current, prior, admin) {
  if (current.recovery) return !prior?.recovery ? (admin ? 'receive' : 'send') : null;
  if (current.operation && current.operation !== prior?.operation) return current.operation.split(':')[0];
  if (admin && current.receive && current.receive !== prior?.receive) return 'receive';
  // Housekeeping is automatic and must never take over the user's navigation.
  return null;
}


export function previousCopyCheckUnavailable(previous, recovering = false) {
  return !!previous && (previous.supported !== true || previous.housekeepingState !== 'current'
    || previous.reason === 'previous_copy_check_unavailable'
    || (previous.reason === 'cache_review_or_recovery_required' && !recovering));
}

// Shared by rendered controls and dispatch-time admission; native gates still decide effects.
export function rendererTransferActionAllowed(status, action, admin) {
  if (status?.actions?.[action] !== true) return false;
  if (!admin && !['export', 'stop', 'checkAgain'].includes(action)) return false;
  if (action === 'stop') return status.stopRequested !== true;
  if (status.available !== true || status.busy === true) return false;
  const recovering = transferAttention(status, admin).recovery;
  if (recovering && !['checkAgain', 'removeFailedImport', 'checkRequestRecovery'].includes(action)) return false;
  if (action === 'prepare' && status.preparation?.enabled === true && status.preparation?.upgradeRequired !== true) return false;
  if (['restorePrevious', 'deletePrevious'].includes(action)) {
    return !previousCopyCheckUnavailable(status.previousCache, recovering) && status.previousCache?.available === true;
  }
  return true;
}
